import { API } from "aws-amplify";
import { getTenant } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_TENANT_INFO: APITypes.Tenant = {
  id: "",
  firstName: "",
  middleName: "",
  lastName: "",
  status: APITypes.TenantStatusType.InActive,
  phoneNumber: "",
  email: "",
  jobTitle: "",
  jobPhone: "",
  jobEmail: "",
  jobContactName: "",
  employer: "",
  income: "",
  cimesCommitted: "",
  jailTime: "",
  lastArrest: "",
  lastUpdated: "",
  totalCredit: "",
  __typename: "Tenant",
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getTenantInfo = async ({
  tenantID,
  authUID,
}: {
  tenantID?: string;
  authUID?: string;
}): Promise<LoaderData<APITypes.Tenant>> => {
  try {
    const response = (await API.graphql({
      query: getTenant,
      variables: {
        id: tenantID,
        authUID,
      },
    })) as { data?: APITypes.GetTenantQuery };

    return {
      success: true,
      data: response.data?.getTenant || EMPTY_TENANT_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_TENANT_INFO,
      error,
    };
  }
};
